var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(
			_vm.systemParameters.Banners && _vm.systemParameters.Banners.slides.length > 0
		)?_c('HomePageBanner'):_vm._e(),(_vm.categories && _vm.categories.length)?_c('ProductCategoryTabs'):_vm._e(),(_vm.trainers && _vm.trainers.length > 0)?_c('HomePageInstructorSection'):_vm._e(),_c('HomePageSignupSteps')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }